'use es6';

import { useEffect } from 'react';
import PropTypes from 'prop-types';
import SidebarError from 'customer-data-sidebar/SidebarError';
import PermissionsError from './PermissionsError';
import { logQueryError } from 'customer-data-sidebar/tracking/loggingActions';
import { jsx as _jsx } from "react/jsx-runtime";
const UniversalSidebarError = ({
  message
}) => {
  useEffect(() => {
    logQueryError('universal sidebar', {
      message
    });
  }, [message]);
  if (!message) {
    return null;
  }
  if (message.includes('message: UNAUTHORIZED')) {
    return /*#__PURE__*/_jsx(PermissionsError, {});
  }
  return /*#__PURE__*/_jsx(SidebarError, {});
};
UniversalSidebarError.propTypes = {
  message: PropTypes.string
};
export default UniversalSidebarError;